import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { Text, Image, Flex, ActionIcon, Container, rem, Tooltip, ContainerProps } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import Logo from '@assets/beyond-the-building-horizontal.png';
import classes from './header.module.css';
import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/browser';
import { useNavigate } from 'react-router-dom';

function Header({ ...containerProps }: ContainerProps) {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const navigate = useNavigate();
  const [fullName, setFullName] = useState<string | null>(null);

  useEffect(() => {
    if (user) {
      fetchUserAttributes()
        .then((userAttributes) => {
          setFullName(`${userAttributes?.given_name} ${userAttributes?.family_name}`);
          Sentry.setUser({
            id: `${user.userId}`,
            username: `${userAttributes?.given_name} ${userAttributes?.family_name}`,
            email: `${userAttributes?.email}`,
          });
        })
        .catch((error) => {
          console.log('error: ', error);
        });
    }
  }, [user]);

  const logout = () => {
    Sentry.setUser(null);
    signOut();
    navigate('/');
  };
  return (
    <Container fluid {...containerProps}>
      {user && (
        <Flex align="center" justify="flex-end" className={classes.userBlock}>
          <Text ta="right" pt={rem(2)} fz="lg">
            Welcome, {fullName}
          </Text>
          <Tooltip label="Logout" withArrow position="bottom">
            <ActionIcon variant="transparent" aria-label="Logout" size="xl" onClick={logout}>
              <IconLogout className={classes.iconLogout} stroke={2} />
            </ActionIcon>
          </Tooltip>
        </Flex>
      )}
      <Flex justify="center">
        <Image src={Logo} className={classes.logo} />
      </Flex>
    </Container>
  );
}

export { Header };
